module.exports = __webpack_public_path__ + "img/bg-small.ae67dd28.svg";